import { render, staticRenderFns } from "./carModel.vue?vue&type=template&id=439a58b8&scoped=true&"
import script from "./carModel.vue?vue&type=script&lang=js&"
export * from "./carModel.vue?vue&type=script&lang=js&"
import style0 from "./carModel.vue?vue&type=style&index=0&id=439a58b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a58b8",
  null
  
)

export default component.exports